/**
 * Il Mondo di Miky 2.0 — theme.js
 * Traduzione della logica client React (context, hooks, componenti interattivi)
 * in vanilla JS su API native Shopify (Cart AJAX API, form clienti, filtri).
 */
(function () {
  'use strict';

  /* ══════════════ Utils ══════════════ */
  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  /* Ogni blocco è isolato: un errore non deve bloccare il resto */
  function safe(fn) { try { fn(); } catch (e) { console.error('[theme]', e); } }

  /* ══════════════ AOS ══════════════ */
  safe(function () {
    if (window.AOS) {
      AOS.init({ duration: 800, easing: 'ease-in-sine', delay: 100, offset: 100 });
    } else {
      // Fallback: se AOS non è disponibile (es. script bloccato),
      // rimuove gli attributi data-aos così gli elementi restano visibili.
      qsa('[data-aos]').forEach(function (el) { el.removeAttribute('data-aos'); });
    }
  });

  // Sicurezza extra: se dopo il load qualche elemento data-aos è ancora
  // nascosto (init fallita o layout cambiato), lo rende visibile.
  window.addEventListener('load', function () {
    setTimeout(function () {
      qsa('[data-aos]').forEach(function (el) {
        if (!el.classList.contains('aos-animate') && getComputedStyle(el).opacity === '0') {
          el.removeAttribute('data-aos');
          el.classList.remove('aos-init');
          el.style.opacity = '';
          el.style.transform = '';
        }
      });
    }, 1500);
  });

  /* ══════════════ Menu mobile (Header.tsx) ══════════════ */
  safe(function () {
    var mobileToggle = qs('[data-mobile-menu-toggle]');
    var mobileMenu = qs('[data-mobile-menu]');
    if (!mobileToggle || !mobileMenu) return;

    function setMenu(open) {
      mobileMenu.classList.toggle('hidden', !open);
      qs('[data-menu-icon]', mobileToggle).classList.toggle('hidden', open);
      qs('[data-close-icon]', mobileToggle).classList.toggle('hidden', !open);
    }

    mobileToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      setMenu(mobileMenu.classList.contains('hidden'));
    });
    document.addEventListener('mousedown', function (e) {
      if (!mobileMenu.contains(e.target) && !mobileToggle.contains(e.target)) {
        setMenu(false);
      }
    });
  });

  /* ══════════════ Dropdown TCG (Navbar.tsx) ══════════════ */
  safe(function () {
    var tcgToggle = qs('[data-tcg-toggle]');
    var tcgDropdown = qs('[data-tcg-dropdown]');
    if (!tcgToggle || !tcgDropdown) return;
    tcgToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      tcgDropdown.classList.toggle('hidden');
    });
    document.addEventListener('mousedown', function (e) {
      var wrap = qs('[data-tcg-dropdown-wrap]');
      if (wrap && !wrap.contains(e.target)) tcgDropdown.classList.add('hidden');
    });
  });

  /* ══════════════ Banner categoria su /collections/all (Navbar.tsx) ══════════════ */
  safe(function () {
    var bannerWrap = qs('[data-collection-banner]');
    var hero = qs('[data-hero]');
    if (!bannerWrap || location.pathname.indexOf('/collections/') === -1) return;
    var params = new URLSearchParams(location.search);
    var cat = params.get('filter.p.m.custom.categoria');
    if (!cat) return;
    var handle = cat.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, '');
    var map = { actionfigures: 'model-kit', yugioh: 'yugioh', dragonball: 'dragonball' };
    handle = map[handle] || handle;
    var img = qs('img', bannerWrap);
    var base = img.getAttribute('data-banner-base');
    img.onerror = function () { img.onerror = null; img.src = img.getAttribute('data-banner-fallback'); };
    img.src = base + 'banner-' + handle + '.jpg';
    if (hero) hero.classList.add('hidden');
    bannerWrap.classList.remove('hidden');
    bannerWrap.classList.add('flex', 'justify-center');
  });

  /* ══════════════ Carrello (CartContext.tsx + Cart.tsx) ══════════════ */
  var cartDrawer = qs('[data-cart-drawer]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('hidden');
    document.body.style.overflow = '';
  }

  function updateCartBadge(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
      el.classList.toggle('flex', count > 0);
    });
  }

  function animateCartIcon() {
    qsa('[data-cart-open]').forEach(function (btn) {
      btn.style.transform = 'scale(1.25)';
      setTimeout(function () { btn.style.transform = 'scale(1)'; }, 400);
    });
  }

  function renderCart(cart) {
    updateCartBadge(cart.item_count);
    if (!cartDrawer) return;

    var itemsWrap = qs('[data-cart-items]', cartDrawer);
    var empty = qs('[data-cart-empty]', cartDrawer);
    var footer = qs('[data-cart-footer]', cartDrawer);
    var countEl = qs('[data-cart-items-count]', cartDrawer);
    var totalEl = qs('[data-cart-total]', cartDrawer);
    var tpl = qs('[data-cart-item-template]');

    countEl.textContent = cart.item_count;
    totalEl.textContent = formatMoney(cart.total_price);
    empty.classList.toggle('hidden', cart.item_count > 0);
    footer.classList.toggle('hidden', cart.item_count === 0);
    itemsWrap.innerHTML = '';

    cart.items.forEach(function (item) {
      var node = tpl.content.cloneNode(true);
      var img = qs('[data-item-image]', node);
      if (item.image) {
        img.src = item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2');
        img.alt = item.product_title;
      } else {
        qs('[data-item-image-wrap]', node).classList.add('hidden');
      }
      qs('[data-item-title]', node).textContent = item.product_title;
      if (item.variant_title && item.variant_title !== 'Default Title') {
        var v = qs('[data-item-variant]', node);
        v.textContent = item.variant_title;
        v.classList.remove('hidden');
      }
      qs('[data-item-price]', node).textContent = formatMoney(item.price);
      qs('[data-item-qty]', node).textContent = item.quantity;
      qs('[data-item-line-total]', node).textContent = formatMoney(item.final_line_price);

      qs('[data-item-minus]', node).addEventListener('click', function () {
        changeQuantity(item.key, item.quantity - 1);
      });
      qs('[data-item-plus]', node).addEventListener('click', function () {
        changeQuantity(item.key, item.quantity + 1);
      });
      qs('[data-item-remove]', node).addEventListener('click', function () {
        changeQuantity(item.key, 0);
      });

      itemsWrap.appendChild(node);
    });
  }

  function refreshCart() {
    return fetch(window.theme.routes.cart + '.js')
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function changeQuantity(key, quantity) {
    return fetch(window.theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function (err) { console.error('Errore aggiornamento carrello:', err); });
  }

  function addToCart(variantId, quantity) {
    return fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Errore'); });
      return r.json();
    }).then(function () {
      animateCartIcon();
      return refreshCart().then(openCart);
    }).catch(function (err) {
      console.error('Errore aggiunta al carrello:', err);
      alert(err.message || 'Errore aggiunta al carrello');
    });
  }

  safe(function () {
    qsa('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', openCart);
    });
    qsa('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeCart);
    });
    var cartOverlay = qs('[data-cart-overlay]');
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var qty = 1;
      if (btn.hasAttribute('data-use-qty')) {
        var qtyEl = qs('[data-qty-value]');
        if (qtyEl) qty = parseInt(qtyEl.textContent, 10) || 1;
      }
      addToCart(btn.getAttribute('data-variant-id'), qty);
    });

    // Badge iniziale
    fetch(window.theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) {
      updateCartBadge(c.item_count);
    });
  });

  /* ══════════════ Auth modal (AuthModal.tsx) ══════════════ */
  safe(function () {
    var authModal = qs('[data-auth-modal]');
    if (!authModal) return;

    function showAuthView(view) {
      qsa('[data-auth-view]', authModal).forEach(function (el) {
        el.classList.toggle('hidden', el.getAttribute('data-auth-view') !== view);
      });
    }
    function openAuth(view) {
      authModal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      showAuthView(view || 'login');
    }
    function closeAuth() {
      authModal.classList.add('hidden');
      document.body.style.overflow = '';
    }
    qsa('[data-auth-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openAuth(btn.getAttribute('data-auth-open')); });
    });
    qsa('[data-auth-switch]', authModal).forEach(function (btn) {
      btn.addEventListener('click', function () { showAuthView(btn.getAttribute('data-auth-switch')); });
    });
    var authClose = qs('[data-auth-close]', authModal);
    if (authClose) authClose.addEventListener('click', closeAuth);
    var authOverlay = qs('[data-auth-overlay]', authModal);
    if (authOverlay) authOverlay.addEventListener('click', closeAuth);
  });

  /* ══════════════ Toggle password (LoginForm/RegisterForm) ══════════════ */
  safe(function () {
    qsa('[data-toggle-password]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('.relative').querySelector('input');
        var isPwd = input.type === 'password';
        input.type = isPwd ? 'text' : 'password';
        qs('[data-eye]', btn).classList.toggle('hidden', isPwd);
        qs('[data-eye-slash]', btn).classList.toggle('hidden', !isPwd);
      });
    });
  });

  /* ══════════════ Newsletter Mailchimp JSONP (Footer.tsx) ══════════════ */
  safe(function () {
    var nlBtn = qs('[data-newsletter-submit]');
    if (!nlBtn) return;
    var nlInput = qs('[data-newsletter-email]');
    var nlSuccess = qs('[data-newsletter-success]');
    var nlError = qs('[data-newsletter-error]');
    var nlLabel = qs('[data-newsletter-label]');

    function submitNewsletter() {
      var email = nlInput.value;
      nlSuccess.classList.add('hidden');
      nlError.classList.add('hidden');
      if (!email || !/\S+@\S+\.\S+/.test(email)) {
        nlError.classList.remove('hidden');
        return;
      }
      nlLabel.textContent = '...';

      var mcUrl = nlBtn.getAttribute('data-mailchimp-url');
      var callbackName = 'mcCallback_' + Date.now();
      var script = document.createElement('script');
      var timeout = setTimeout(function () { cleanup(); fail(); }, 8000);

      function cleanup() {
        clearTimeout(timeout);
        delete window[callbackName];
        if (script.parentNode) script.parentNode.removeChild(script);
        nlLabel.textContent = 'Iscriviti';
      }
      function fail() { nlError.classList.remove('hidden'); }

      window[callbackName] = function (data) {
        cleanup();
        if (data.result === 'success') {
          nlSuccess.classList.remove('hidden');
          nlInput.value = '';
        } else {
          fail();
        }
      };

      var uParam = (mcUrl.match(/[?&]u=([^&]+)/) || [])[1] || '';
      var idParam = (mcUrl.match(/[?&]id=([^&]+)/) || [])[1] || '';
      script.setAttribute('data-cookieconsent', 'ignore');
      script.src = mcUrl + '&EMAIL=' + encodeURIComponent(email) + '&b_' + uParam + '_' + idParam + '=&c=' + callbackName;
      document.body.appendChild(script);
    }

    nlBtn.addEventListener('click', submitNewsletter);
    nlInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') submitNewsletter(); });
  });

  /* ══════════════ Filtri e ordinamento collezione (FiltersPanel.tsx) ══════════════ */
  safe(function () {
    var filtersForm = qs('[data-filters-form]');
    if (!filtersForm) return;

    // Mostra/nasconde pannello filtri
    var panelToggle = qs('[data-filter-panel-toggle]', filtersForm);
    var panel = qs('[data-filter-panel]', filtersForm);
    var panelLabel = qs('[data-filter-panel-label]', filtersForm);
    if (panelToggle && panel) {
      panelToggle.addEventListener('click', function () {
        var hidden = panel.classList.toggle('hidden');
        panelLabel.textContent = hidden ? 'Mostra filtro' : 'Nascondi filtro';
      });
    }

    // Dropdown ordinamento
    var sortToggle = qs('[data-sort-toggle]', filtersForm);
    var sortDropdown = qs('[data-sort-dropdown]', filtersForm);
    if (sortToggle && sortDropdown) {
      sortToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        sortDropdown.classList.toggle('hidden');
      });
      qsa('[data-sort-value]', sortDropdown).forEach(function (btn) {
        btn.addEventListener('click', function () {
          filtersForm.querySelector('input[name="sort_by"]').value = btn.getAttribute('data-sort-value');
          filtersForm.submit();
        });
      });
      document.addEventListener('mousedown', function (e) {
        if (!qs('[data-sort-wrap]', filtersForm).contains(e.target)) sortDropdown.classList.add('hidden');
      });
    }

    // Dropdown gruppi filtro
    qsa('[data-filter-group]', filtersForm).forEach(function (group) {
      var toggle = qs('[data-filter-group-toggle]', group);
      var dropdown = qs('[data-filter-group-dropdown]', group);
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        qsa('[data-filter-group-dropdown]', filtersForm).forEach(function (d) {
          if (d !== dropdown) d.classList.add('hidden');
        });
        dropdown.classList.toggle('hidden');
      });
    });
    document.addEventListener('mousedown', function (e) {
      if (!filtersForm.contains(e.target)) {
        qsa('[data-filter-group-dropdown]', filtersForm).forEach(function (d) { d.classList.add('hidden'); });
      }
    });

    // Submit automatico al cambio checkbox
    qsa('[data-filter-checkbox]', filtersForm).forEach(function (cb) {
      cb.addEventListener('change', function () { filtersForm.submit(); });
    });
  });

  /* ══════════════ Pagina prodotto (productdetail.tsx) ══════════════ */
  safe(function () {
    var buyArea = qs('[data-buy-area]');
    if (!buyArea) return;

    // Quantità
    var qtyValue = qs('[data-qty-value]');
    var qtyMinus = qs('[data-qty-minus]');
    var qtyPlus = qs('[data-qty-plus]');
    var maxAvailable = null;

    function currentVariantBtn() {
      return qs('[data-variant-button].border-pink-500');
    }

    function setMaxFromButton(btn) {
      var q = btn ? btn.getAttribute('data-variant-qty') : '';
      maxAvailable = q ? parseInt(q, 10) : null;
    }
    setMaxFromButton(currentVariantBtn());

    if (qtyMinus && qtyPlus && qtyValue) {
      qtyMinus.addEventListener('click', function () {
        var q = parseInt(qtyValue.textContent, 10);
        qtyValue.textContent = Math.max(1, q - 1);
      });
      qtyPlus.addEventListener('click', function () {
        var q = parseInt(qtyValue.textContent, 10);
        if (maxAvailable == null || q < maxAvailable) qtyValue.textContent = q + 1;
      });
    }

    // Galleria
    var mainImage = qs('[data-main-image]');
    qsa('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        qsa('[data-thumb]').forEach(function (t) {
          t.classList.remove('border-pink-500');
          t.classList.add('border-transparent');
        });
        thumb.classList.add('border-pink-500');
        thumb.classList.remove('border-transparent');
        if (mainImage) mainImage.src = thumb.getAttribute('data-image-url');
      });
    });

    // Varianti
    var priceEl = qs('[data-product-price]');
    var compareEl = qs('[data-compare-price]');
    var saleBadge = qs('[data-sale-badge]');
    var addBtn = qs('[data-add-to-cart][data-use-qty]');
    qsa('[data-variant-button]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-variant-available') !== 'true') return;
        qsa('[data-variant-button]').forEach(function (b) {
          b.classList.remove('border-pink-500', 'bg-pink-500/20', 'text-pink-300');
          if (b.getAttribute('data-variant-available') === 'true') {
            b.classList.add('border-white/20', 'text-white/70');
          }
        });
        btn.classList.remove('border-white/20', 'text-white/70');
        btn.classList.add('border-pink-500', 'bg-pink-500/20', 'text-pink-300');

        if (priceEl) priceEl.textContent = btn.getAttribute('data-variant-price');
        var cmp = btn.getAttribute('data-variant-compare-price');
        if (compareEl) {
          compareEl.textContent = cmp || '';
          compareEl.classList.toggle('hidden', !cmp);
        }
        if (saleBadge) saleBadge.classList.toggle('hidden', !cmp);
        if (addBtn) addBtn.setAttribute('data-variant-id', btn.getAttribute('data-variant-id'));

        var imgUrl = btn.getAttribute('data-variant-image');
        if (imgUrl && mainImage) mainImage.src = imgUrl;

        setMaxFromButton(btn);
        if (maxAvailable != null && qtyValue) {
          var q = parseInt(qtyValue.textContent, 10);
          if (q > maxAvailable) qtyValue.textContent = maxAvailable;
        }

        // URL variante
        var url = new URL(location.href);
        url.searchParams.set('variant', btn.getAttribute('data-variant-id'));
        history.replaceState({}, '', url);
      });
    });
  });

  /* ══════════════ Prodotti correlati (recommendations) ══════════════ */
  safe(function () {
    var el = qs('[data-recommendations]');
    if (!el || el.querySelector('.grid')) return;
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
      })
      .catch(function () { /* opzionale */ });
  });

  /* ══════════════ Ricerca blog client-side (BlogPage.tsx) ══════════════ */
  safe(function () {
    var input = qs('[data-blog-search]');
    if (!input) return;
    var clearBtn = qs('[data-blog-search-clear]');
    var cards = qsa('[data-article-card]');
    var emptyMsg = qs('[data-blog-empty]');
    var countMsg = qs('[data-blog-count]');

    function apply() {
      var q = input.value.trim().toLowerCase();
      var visible = 0;
      cards.forEach(function (card) {
        var match = !q || card.getAttribute('data-title').indexOf(q) !== -1;
        card.classList.toggle('hidden', !match);
        if (match) visible++;
      });
      if (clearBtn) clearBtn.classList.toggle('hidden', !q);
      if (emptyMsg) emptyMsg.classList.toggle('hidden', visible > 0);
      if (countMsg) {
        countMsg.classList.toggle('hidden', !q);
        countMsg.textContent = visible + ' risultat' + (visible === 1 ? 'o' : 'i') + ' per "' + input.value + '"';
      }
    }

    input.addEventListener('input', apply);
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; apply(); });
  });

  /* ══════════════ Filtri eventi client-side (events.tsx) ══════════════ */
  safe(function () {
    var wrap = qs('[data-events-wrap]');
    if (!wrap) return;
    var checkboxes = qsa('[data-event-category-filter]');
    var dateInput = qs('[data-event-date-filter]');
    var clearBtn = qs('[data-events-clear]');
    var emptyMsg = qs('[data-events-empty]');
    var totalEl = qs('[data-events-total]');

    function apply() {
      var activeCats = checkboxes.filter(function (c) { return c.checked; }).map(function (c) { return c.value; });
      var selectedDate = dateInput ? dateInput.value : '';
      var visibleTotal = 0;

      qsa('[data-event-section]', wrap).forEach(function (section) {
        var cat = section.getAttribute('data-category');
        var catMatch = activeCats.length === 0 || activeCats.indexOf(cat) !== -1;
        var visibleInSection = 0;

        qsa('[data-event-card]', section).forEach(function (card) {
          var d = card.getAttribute('data-date') || '';
          var dateMatch = !selectedDate || d === selectedDate;
          var show = catMatch && dateMatch;
          card.classList.toggle('hidden', !show);
          if (show) visibleInSection++;
        });

        section.classList.toggle('hidden', visibleInSection === 0);
        var countEl = qs('[data-event-section-count]', section);
        if (countEl) countEl.textContent = visibleInSection + ' evento' + (visibleInSection === 1 ? '' : 'i');
        visibleTotal += visibleInSection;
      });

      if (emptyMsg) emptyMsg.classList.toggle('hidden', visibleTotal > 0);
      if (totalEl) totalEl.textContent = visibleTotal + ' eventi';
      if (clearBtn) clearBtn.classList.toggle('hidden', activeCats.length === 0 && !selectedDate);
    }

    checkboxes.forEach(function (cb) { cb.addEventListener('change', apply); });
    if (dateInput) dateInput.addEventListener('change', apply);
    if (clearBtn) clearBtn.addEventListener('click', function () {
      checkboxes.forEach(function (cb) { cb.checked = false; });
      if (dateInput) dateInput.value = '';
      apply();
    });

    // Dropdown pill filtri eventi
    qsa('[data-filter-group]', wrap.parentElement || document).forEach(function (group) {
      var toggle = qs('[data-filter-group-toggle]', group);
      var dropdown = qs('[data-filter-group-dropdown]', group);
      if (!toggle || !dropdown) return;
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        dropdown.classList.toggle('hidden');
      });
    });
  });

  /* ══════════════ Gift card: selettore importo (giftcard.tsx) ══════════════ */
  safe(function () {
    var amountBtns = qsa('[data-amount-button]');
    if (!amountBtns.length) return;
    var priceEl = qs('[data-giftcard-price]');
    var addBtn = qs('[data-add-to-cart][data-use-qty]');

    amountBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        amountBtns.forEach(function (b) {
          b.classList.remove('border-pink-500', 'bg-pink-500/20', 'text-pink-300', 'shadow-lg', 'shadow-pink-500/20');
          if (!b.disabled) b.classList.add('border-white/20', 'text-white/70');
        });
        btn.classList.remove('border-white/20', 'text-white/70');
        btn.classList.add('border-pink-500', 'bg-pink-500/20', 'text-pink-300', 'shadow-lg', 'shadow-pink-500/20');
        if (priceEl) priceEl.textContent = btn.getAttribute('data-amount-price');
        if (addBtn) addBtn.setAttribute('data-variant-id', btn.getAttribute('data-variant-id'));
      });
    });
  });

  /* ══════════════ Tab account (ProfilePage.tsx) ══════════════ */
  safe(function () {
    var tabs = qsa('[data-account-tab]');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-account-tab');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('bg-white/10', active);
          t.classList.toggle('border-pink-500', active);
          t.classList.toggle('text-pink-400', active);
          t.classList.toggle('border-transparent', !active);
          t.classList.toggle('text-white/70', !active);
        });
        qsa('[data-account-panel]').forEach(function (panel) {
          panel.classList.toggle('hidden', panel.getAttribute('data-account-panel') !== target);
        });
      });
    });
  });

  /* ══════════════ Ordini: accordion + ricerca (OrdersHistory.tsx) ══════════════ */
  safe(function () {
    var list = qs('[data-order-list]');
    if (!list) return;

    /* Apre/chiude il dettaglio del singolo ordine */
    qsa('[data-order-toggle]', list).forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var card = toggle.closest('[data-order-card]');
        var body = qs('[data-order-body]', card);
        var chevron = qs('svg', toggle);
        if (!body) return;
        var open = body.classList.toggle('hidden') === false;
        toggle.setAttribute('aria-expanded', String(open));
        if (chevron) chevron.classList.toggle('rotate-180', open);
      });
    });

    /* Filtra gli ordini della pagina per nome prodotto */
    var input = qs('[data-order-search]');
    if (!input) return;
    var cards = qsa('[data-order-card]', list);
    var count = qs('[data-order-count]');
    var empty = qs('[data-order-empty]');

    input.addEventListener('input', function () {
      var query = input.value.trim().toLowerCase();
      var visible = 0;

      cards.forEach(function (card) {
        var match = !query || (card.getAttribute('data-order-text') || '').indexOf(query) !== -1;
        card.classList.toggle('hidden', !match);
        if (match) visible++;
      });

      if (count) {
        count.classList.toggle('hidden', !query);
        count.textContent = visible === 1 ? '1 ordine trovato' : visible + ' ordini trovati';
      }
      if (empty) empty.classList.toggle('hidden', visible !== 0);
    });
  });
})();
